import { __assign, __extends, __rest } from "tslib";
import { Component } from 'react';
import I18nContext from './I18nContext';
var I18nReceiver = (function (_super) {
    __extends(I18nReceiver, _super);
    function I18nReceiver() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    I18nReceiver.prototype.receive = function () {
        var _a = this.props, componentName = _a.componentName, defaultI18n = _a.defaultI18n;
        var zentI18n = this.context;
        var i18n = (zentI18n && zentI18n[componentName]) || {};
        return __assign(__assign(__assign({}, (typeof defaultI18n === 'function' ? defaultI18n() : defaultI18n)), (typeof i18n === 'function' ? i18n() : i18n)), { mark: (zentI18n && zentI18n.mark) || 'zh-CN' });
    };
    I18nReceiver.prototype.render = function () {
        var _a = this.props, children = _a.children, componentName = _a.componentName, defaultI18n = _a.defaultI18n, bypass = __rest(_a, ["children", "componentName", "defaultI18n"]);
        return children(this.receive(), bypass);
    };
    I18nReceiver.contextType = I18nContext;
    return I18nReceiver;
}(Component));
export default I18nReceiver;
